<template>
    <div>
        <el-card class="box-card">
            <div slot="header" class="card-header">
                <span>录取结果统计</span>
                <div class="card-tools">
                    <ul class="nav">
                        <li class="nav-item" style="margin-right: 5px;">
                            <el-select v-model="searchForm.BatchId" placeholder="请选择" class="width_100Pie" @change="onChangeBatch">
                                <el-option v-for="item in optBatch" :key="item.batchId" :label="item.name" :value="item.batchId">
                                </el-option>
                            </el-select>
                        </li>
                        <li class="nav-item">
                            <el-button style="background-color:#17a2b8	;color: white;" icon="el-icon-download" @click="onOpenExport()" v-if="isPower.statistics_enroll_export">导出</el-button>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="card-body p-0" v-if="itemData!=null && itemData.length!=1">
                <el-table stripe :data="itemData" class="elTableData" :span-method="arraySpanMethod" :cell-style="cellStyle">
                    <el-table-column type="index" label="序号" width="80"></el-table-column>
                    <el-table-column prop="name" label="专业名称" min-width="200" :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column prop="plan" label="计划招生人数" min-width="120" :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column prop="enroll" label="已录取人数" min-width="120" :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column prop="rest" label="剩余名额" min-width="120" :show-overflow-tooltip="true">
                    </el-table-column>
                </el-table>
            </div>
            <div class="card-body " v-else>
                <el-empty :image-size="200" description="暂无数据" name="3"></el-empty>
            </div>
        </el-card>
    </div>
</template>

<script>
export default {
    components: {
    },
    data() {
        return {
            fullscreenLoading: false,
            dialogVisible: false,
            random: 0,
            itemData: null,
            
            searchForm: {
                BatchId: null
            },
            searchFormReset: null,
            optBatch: [],
            isPower: {
                //增删改查 权限管理
                statistics_enroll_export: false,
            },
        }
    },
    created() {
        let that = this;

        isPower(that, "statistics_enroll_export", "statistics_enroll_export");

        ajaxGet(that, "/api/admin/enrollbatch", null, function (resBatch) {
            if (resBatch && resBatch.length > 0) {
                that.optBatch = resBatch;
                that.searchForm.BatchId = that.optBatch[0].batchId;
            }

            that.searchFormReset = JSON.parse(JSON.stringify(that.searchForm));

            onGetDataPage(that);
        })
    },
    watch: {
      '$route': function(to) {
        let that = this;
        onGetDataPage(that);
      },
    },
    methods: {
        onChangeBatch() {
            let that = this;
            onGetDataPage(that);
        },
        onResetSearch() {
            let that = this;
            that.searchForm = JSON.parse(JSON.stringify(that.searchFormReset));
            onGetDataPage(that)
        },
        cellStyle({rowIndex, columnIndex}) {
            if (rowIndex === this.itemData.length - 1 && columnIndex === 1) {
                return 'text-align: center';
            }
        },
        arraySpanMethod({ rowIndex, columnIndex }) {
            if (rowIndex == this.itemData.length - 1) {
                if (columnIndex === 0) {
                    return [0, 0];
                } else if (columnIndex === 1) {
                    return [1, 2];
                }
            }
        },
        onOpenExport() {
            let that = this;
            let fileName = '录取结果统计' + that.$UploadTime() + '.xls';
            let data = {
                BatchId: that.searchForm.BatchId,
            };
            that.fullscreenLoading = true;
            ajaxExport(that, '/api/admin/enrollmajor/exportenrollstatistics', data, fileName, function (res) {
                that.fullscreenLoading = false;
            })
        },
        onSearch()// 搜索
        {
            let that = this
            onGetDataPage(that);
        },
    },
}
// 分页获取数据
function onGetDataPage(that) {
    let data = {
        BatchId: that.searchForm.BatchId,
    };
    that.itemData = [];
    that.fullscreenLoading = true;
    ajaxGet(that, "/api/admin/enrollmajor/majorstatistics", data, function (r) {
        if (r && r.length > 0) {
            that.itemData = r;
            var totalData = {
                name: "合计",
                plan: 0,
                enroll: 0,
                rest: 0
            }
            that.itemData.forEach(ele => {
                totalData.plan += ele.plan;
                totalData.enroll += ele.enroll;
                totalData.rest += ele.rest;
            })
            that.itemData.push(totalData);
            that.fullscreenLoading = false;
        }
        
    });
}
</script>

<style lang="less" scoped>
/deep/ .el-table .warning-row {
    text-align: center;
}
.selTitleBox {

font-size: 14px;
}

.selTitleBox .spTitle {
color: #303133;
}

.selBodyBox {
padding-top: 5px;
}
</style>